import confetti from "canvas-confetti";

const YELLOW = "#FFD600";
const NAVY = "#0F172A";
const RED = "#E63946";

export function popConfetti(origin = { x: 0.5, y: 0.5 }) {
  confetti({
    particleCount: 60,
    spread: 70,
    origin,
    colors: [YELLOW, NAVY, RED, "#ffffff"],
    scalar: 0.9,
    ticks: 140,
  });
}

export function burstFromElement(el) {
  if (!el) return;
  const r = el.getBoundingClientRect();
  const x = (r.left + r.width / 2) / window.innerWidth;
  const y = (r.top + r.height / 2) / window.innerHeight;
  popConfetti({ x, y });
}

export function fireworks() {
  const duration = 1200;
  const end = Date.now() + duration;
  const colors = [YELLOW, NAVY, "#ffffff"];
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
